export function HandleAdd(joinTable, item, setOrder,
                          setSelectedItem, toAddList,
                          addItems, setAddItems, availableItems,
                          setToolOrLayers, selectedValue, setSelectedValue,
                          itemsToSelect, setItemsToSelect){

    setToolOrLayers(current => [...current, item])

    setSelectedValue(null)
    setOrder(null)
    setSelectedItem(null)

    toAddList = addItems
    toAddList.push(joinTable)
    setAddItems(toAddList)

    availableItems = itemsToSelect
    availableItems = availableItems.filter(e => e.value !== selectedValue);
    setItemsToSelect(availableItems)
}